import { useMemo } from 'react';
import { translations } from 'app/locales/i18n';
import {
  CellAlignment,
  CellSize,
} from 'app/shared/components/generic-ui/Table/Table.types';
import { useTranslation } from 'react-i18next';
import RefreshIcon from 'assets/refresh.svg?react';
import { CustomTypography } from 'app/shared/components/generic-ui/Typography/Typography';
import { mapDropdowns } from './useBatchHistoryTableConfig';

export const useHistoryTableConfig = (
  onButtonClick: () => void,
  statuses: Record<string, string[]>,
) => {
  const { t } = useTranslation();

  const button = useMemo(() => {
    return (
      <div
        onClick={onButtonClick}
        style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer' }}
      >
        <RefreshIcon style={{ marginRight: 6 }} />
        <CustomTypography variant="subtitle2" bold color="mbsBlue">
          {t(translations.pourEventPage.refresh)}
        </CustomTypography>
      </div>
    );
  }, [onButtonClick, t]);
  const keys = useMemo(() => Object.keys(statuses), [statuses]);

  const defaultTableColumns = useMemo(() => {
    const firstKey =
      keys.find(key => key === localStorage.getItem('status1')) || keys[0];
    const secondKey =
      keys.find(key => key === localStorage.getItem('status2')) || keys[1];
    const thirdKey =
      keys.find(key => key === localStorage.getItem('status3')) || keys[2];
    const fourthKey =
      keys.find(key => key === localStorage.getItem('status4')) || keys[3];

    const dropDownValues = mapDropdowns(keys);
    return [
      {
        id: 'empty',
        label: '',
        alignment: CellAlignment.LEFT,
        size: CellSize.MEDIUM,
        rowNumber: 1,
        colSpan: 7,
        buttons: [
          {
            button: button,
            onClick: onButtonClick,
          },
        ],
      },
      {
        id: 'status1',
        label: firstKey,
        alignment: CellAlignment.CENTER,
        size: CellSize.MEDIUM,
        rowNumber: 1,
        dropDownValues: dropDownValues,
      },
      {
        id: 'status2',
        label: secondKey,
        alignment: CellAlignment.CENTER,
        size: CellSize.MEDIUM,
        rowNumber: 1,
        dropDownValues: dropDownValues,
      },
      {
        id: 'status3',
        label: thirdKey,
        alignment: CellAlignment.CENTER,
        size: CellSize.MEDIUM,
        rowNumber: 1,
        dropDownValues: dropDownValues,
      },
      {
        id: 'status4',
        label: fourthKey,
        alignment: CellAlignment.CENTER,
        size: CellSize.MEDIUM,
        rowNumber: 1,
        dropDownValues: dropDownValues,
      },
      {
        id: 'actions',
        label: '',
        alignment: CellAlignment.LEFT,
        size: CellSize.SMALL,
        rowNumber: 1,
        colSpan: 1,
      },
      {
        id: 'historyType',
        label: '',
        alignment: CellAlignment.CENTER,
        size: CellSize.MEDIUM,
        rowNumber: 2,
        colSpan: 1,
      },
      {
        id: 'vehicleId',
        label: `${t(translations.pourEventPage.truck)} #`,
        alignment: CellAlignment.RIGHT,
        size: CellSize.MEDIUM,
        rowNumber: 2,
        colSpan: 1,
      },
      {
        id: 'ticketNumber',
        label: t(translations.pourEventPage.ticketId),
        alignment: CellAlignment.RIGHT,
        size: CellSize.MEDIUM,
        rowNumber: 2,
        colSpan: 1,
      },

      {
        id: 'batchAge',
        label: t(translations.pourEventPage.batchAge),
        alignment: CellAlignment.LEFT,
        size: CellSize.MEDIUM,
        rowNumber: 2,
        colSpan: 1,
      },
      {
        id: 'historyRecordName',
        label: t(translations.pourEventPage.statusAlert),
        alignment: CellAlignment.LEFT,
        size: CellSize.MEDIUM,
        rowNumber: 2,
        colSpan: 1,
      },
      {
        id: 'loadNumber',
        label: `${t(translations.pourEventPage.load)} #`,
        alignment: CellAlignment.RIGHT,
        size: CellSize.MEDIUM,
        rowNumber: 2,
      },
      {
        id: 'totalOrdered',
        label: t(translations.pourEventPage.volumeTotalOrder),
        alignment: CellAlignment.RIGHT,
        size: CellSize.MEDIUM,
        rowNumber: 2,
      },
      {
        id: 'property1',
        label:
          statuses[firstKey].find(
            key => key === localStorage.getItem('property1'),
          ) || statuses[firstKey][0],
        alignment: CellAlignment.CENTER,
        size: CellSize.MEDIUM,
        rowNumber: 2,
        colSpan: 1,
        dropDownValues: mapDropdowns(statuses[firstKey]),
      },
      {
        id: 'property2',
        label:
          statuses[secondKey].find(
            key => key === localStorage.getItem('property2'),
          ) || statuses[secondKey][1],
        alignment: CellAlignment.CENTER,
        size: CellSize.MEDIUM,
        rowNumber: 2,
        colSpan: 1,
        dropDownValues: mapDropdowns(statuses[secondKey]),
      },
      {
        id: 'property3',
        label:
          statuses[thirdKey].find(
            key => key === localStorage.getItem('property3'),
          ) || statuses[thirdKey][2],
        alignment: CellAlignment.CENTER,
        size: CellSize.MEDIUM,
        rowNumber: 2,
        colSpan: 1,
        dropDownValues: mapDropdowns(statuses[thirdKey]),
      },
      {
        id: 'property4',
        label:
          statuses[fourthKey].find(
            key => key === localStorage.getItem('property4'),
          ) || statuses[fourthKey][3],
        alignment: CellAlignment.CENTER,
        size: CellSize.MEDIUM,
        rowNumber: 2,
        colSpan: 1,
        dropDownValues: mapDropdowns(statuses[fourthKey]),
      },
      {
        id: 'actions',
        label: '',
        alignment: CellAlignment.LEFT,
        size: CellSize.SMALL,
        rowNumber: 2,
        colSpan: 1,
      },
    ];
  }, [keys, button, onButtonClick, t, statuses]);

  return {
    defaultColumns: defaultTableColumns,
  };
};
